import { InboxPagev2 } from './InboxPagev2';

export const InboxWrapper = () => {
  return <InboxPagev2 />;
};
